module.exports = __webpack_public_path__ + "img/睡眠状态呢.c5d4d058.png";